import Component from '../abstracts/Component';
import {isMobile, MobileBreakpoint} from '../utils/MobileUtils';
import FiltersComponent from '../components/FiltersComponent';
import PriceRangeComponent from '../components/PriceRangeComponent';
import SaleRangeComponent from '../components/SaleRangeComponent';

export default class ActiveFiltersComponent extends Component {
  get SELECTORS() {
    return {
      activeFiltersContainer: '[data-active-filters]',
      selectedFilter: '[data-selected-filter]',
      removeFilters: '[data-remove-filters]',
      removeFiltersEmptySearch: '[data-empty-search]',
      activeFiltersCount: '[data-active-filters-count]',
      productsContainer: '[data-products-container]'
    }
  }

  get CLASSES() {
    return {
      hidden: '--hidden'
    }
  }

  constructor(htmlEl) {
    super(htmlEl);
    this.activeFiltersContainer = document.querySelector(this.SELECTORS.activeFiltersContainer);
    this.removeFilters = document.querySelector(this.SELECTORS.removeFilters);
    this.removeFiltersEmptySearch = document.querySelector(this.SELECTORS.removeFiltersEmptySearch);
    this.FiltersComponent = new FiltersComponent(htmlEl);
    this.PriceRangeComponent = new PriceRangeComponent(htmlEl);
    this.SaleRangeComponent = new SaleRangeComponent(htmlEl);
  }

  bindEvents() {
    this.$on(this.$customEvents.FILTERS_EVENTS.updated, ({e, payload}) => {
      this.checkFiltersDisplayed(payload.response);
    });

    if(this.removeFilters) {
      this.removeFilters.addEventListener('click', (e) => {
        this.FiltersComponent.resetFilters();
      });
    }

    if(this.removeFiltersEmptySearch) {
      this.removeFiltersEmptySearch.addEventListener('click', (e) => {
        this.FiltersComponent.resetFilters();
      });
    }

    $(document).ready(() => {
      this.checkFiltersDisplayed(document);
    });
  }

  checkFiltersDisplayed(response) {
    const newActiveFilters = response.querySelector(this.SELECTORS.activeFiltersContainer);
    const newNumberActiveFilters = response.querySelectorAll(this.SELECTORS.selectedFilter).length;

    if( newNumberActiveFilters > 0) {
      //insert new filters
      //this.activeFiltersContainer.classList.remove(this.CLASSES.hidden);
      this.activeFiltersContainer.innerHTML = newActiveFilters.innerHTML;
      this.bindNewFilters();
      this.removeFilters.classList.remove(this.CLASSES.hidden);
      this.removeFiltersEmptySearch.classList.add(this.CLASSES.hidden);
    }
    else {
      this.activeFiltersContainer.innerHTML ='';
      this.removeFilters.classList.add(this.CLASSES.hidden);
      if(newNumberActiveFilters == 0 &&  response.querySelector(this.SELECTORS.productsContainer).children.length == 0) {
        this.removeFiltersEmptySearch.classList.remove(this.CLASSES.hidden);
      }
   }
  }

  bindNewFilters() {
    this.activeFiltersContainer.querySelectorAll(this.SELECTORS.selectedFilter).forEach(filter => {
      filter.querySelector('.icon-close').addEventListener('click', () => {
        this.isReset = false;
        if (filter.classList.contains('price-filter')) {
          this.PriceRangeComponent.resetSlider();
          this.isReset = true;
        }

        if (filter.classList.contains('sale-range-filter')) {
          this.SaleRangeComponent.resetInputs();
        }

        if (filter.dataset.facetId != '') {
          let filterId = '#' + filter.dataset.facetId;
          document.querySelector(filterId).checked = false;
          if(this.activeFiltersContainer.children.length == 1){
            this.isReset = true;
          }
        }

        this.applyChanges(this.isReset);
      });
    });

    this.removeFilters = this.activeFiltersContainer.querySelector(this.SELECTORS.removeFilters);
    this.removeFiltersEmptySearch = this.activeFiltersContainer.querySelector(this.SELECTORS.removeFiltersEmptySearch);

    if(this.removeFilters) {
      this.removeFilters.addEventListener('click', (e) => {
        this.FiltersComponent.resetFilters();
      });
    }

    if(this.removeFiltersEmptySearch) {
      this.removeFiltersEmptySearch.addEventListener('click', (e) => {
        this.FiltersComponent.resetFilters();
      });
    }
  }

  applyChanges(isReset = false) {
    this.FiltersComponent.applyFilters(isReset);
    this.FiltersComponent.updateFiltersCounter();
  }

  render() {
    super.render();
    if (!isMobile(MobileBreakpoint.Max1023)) {
      this.bindEvents();
    }
  }
}
